// 3D-Secure 2.0 requires "device data", but at least one of the required
// fields is typically available in web browsers and not on mobile devices:
// color_depth. On mobile, we use a WebView for this (and being there, for
// the rest of the fields too). The actual JS executed in the WebView comes
// from the backend for easier updates.
// Refs:
// - MFL API docs: Shop / Orders / Checkout - Checks out the order.
//   https://dev.azure.com/lmgdevops/branded_website/_wiki/wikis/branded_website.wiki/29/3rd-party-APIs
// - https://gateway.tillpayments.com/documentation/apiv3#transaction-data-3d-secure-2-0-device-data
export const mobileWebView3DsBrowserDataHtml =
  '<!DOCTYPE html><html><body></body></html>';

export function getWeb3DsBrowserData() {
  return {
    java_enabled:
      typeof window.navigator.javaEnabled === 'function'
        ? window.navigator.javaEnabled()
        : false,
    language: window.navigator?.language,
    color_depth: window.screen?.colorDepth,
    screen_height: window.screen?.height,
    screen_width: window.screen?.width,
    timezone: new Date().getTimezoneOffset(),
  };
}
